import { LoanTypes } from 'src/constants/globalConstants';

export const PAGES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  UPDATE_PASSWORD: '/update-password',
  INVESTMENTS: '/investments',
  OUTSTANDING_BIDS: '/outstanding-bids',
  OPPORTUNITIES: '/opportunities',
  PORTFOLIO_BUILDER: '/portfolio-builder',
  NEW_ALLOCATION: '/portfolio-builder/new-allocation/',
  VIEW_ALLOCATION: '/portfolio-builder/view-allocation/:id',
  EDIT_ALLOCATION: '/portfolio-builder/edit-allocation/:id',
  PLATFORM_ANALYTICS: '/platform-analytics',
  STATISTICS: '/statistics',
  REPORTS: '/transactions',
  MARKETPLACE: '/marketplace',
  MARKETPLACE_CONSUMER: '/marketplace/consumer',
  MARKETPLACE_SME: '/marketplace/sme',
  MARKETPLACE_INVOICE_FINANCING: '/marketplace/invoice-financing',
  HELP_CENTER: '/help-center',
  ERROR_404: '*',
  SERVER_ERROR: '/server-error',
  SIGN_IN: '/sign-in',
  CHOOSE_ACCOUNT_TYPE: '/choose-account-type',
  MY_PROFILE: '/my-profile',
  SETTINGS_AND_PRIVACY: '/settings-and-privacy',
  PASSWORD_RECOVERY: '/password-recovery',
  CONFIRM_PASSWORD_RECOVERY: '/confirm-password-recovery/',
  CHANGE_PASSWORD_SUCCESS: '/change-password-success/',
  API_SETTINGS: '/api-settings',
  MARKETPLACE_CONSUMER_DETAILS: '/marketplace/consumer/:id',
  MARKETPLACE_SME_DETAILS: '/marketplace/sme/:id',
  MARKETPLACE_INVOICE_FINANCING_DETAILS: '/marketplace/invoice-financing/:id',
  OPPORTUNITY_DETAILS: '/opportunities/:id',
  INVESTMENT_DETAILS: '/investments/:id',
  BID_DETAILS: '/outstanding-bids/:id',
  WORKSPACES_CREATE: '/workspaces/create',
  WORKSPACES_CHOOSE: '/choose-workspace',
  WORKSPACES_MANAGEMENT: '/workspaces/management',
  WORKSPACES_ACCESS: '/workspaces/:id/access'
};

export const DYNAMIC_PAGES = {
  VIEW_ALLOCATION: (id: string): string => `/portfolio-builder/view-allocation/${id}`,
  EDIT_ALLOCATION: (id: string): string => `/portfolio-builder/edit-allocation/${id}`,
  MARKETPLACE_DETAILS: (id: string, loanType: LoanTypes): string => {
    const loanTypePath: { [key in LoanTypes]: string } = {
      [LoanTypes.CONSUMER]: 'consumer',
      [LoanTypes.SME]: 'sme',
      [LoanTypes.INVOICE_FINANCING]: 'invoice-financing'
    };

    return `/marketplace/${loanTypePath[loanType]}/${id}`;
  },
  OPPORTUNITY_DETAILS: (id: string): string => `/opportunities/${id}`,
  INVESTMENT_DETAILS: (id: string): string => `/investments/${id}`,
  BID_DETAILS: (id: string): string => `/outstanding-bids/${id}`,
  WORKSPACES_ACCESS: (id: string): string => `/workspaces/${id}/access`
};
